import { Group, Paper, Stack, Text } from '@mantine/core';
import { ReactNode } from 'react';
import { StatusBadge } from '../../../common/StatusBadge';
import type { DisplayStatus } from '../../../../types/status';
import { formatThroughQuarterLabel } from '../../formatThroughQuarterLabel';

function mapToneToStatus(tone: 'green' | 'blue' | 'yellow' | 'red' | 'gray'): DisplayStatus {
  switch (tone) {
    case 'green':
      return 'approved';
    case 'yellow':
      return 'pending';
    case 'red':
      return 'needs_attention';
    case 'blue':
      return 'in_review';
    case 'gray':
    default:
      return 'not_submitted';
  }
}

export function CardShell({
  title,
  subtitle,
  statusLabel,
  statusColor,
  statusTooltip,
  children,
}: {
  title: string;
  subtitle: string;
  statusLabel?: string;
  statusColor?: 'green' | 'blue' | 'yellow' | 'red' | 'gray';
  statusTooltip?: string;
  children: ReactNode;
}) {
  return (
    <Paper
      p="lg"
      radius="lg"
      withBorder
      sx={(t) => ({
        backgroundColor: t.colorScheme === 'dark' ? t.colors.dark[7] : t.white,
        borderColor: t.colorScheme === 'dark' ? t.colors.dark[5] : t.colors.gray[3],
      })}
    >
      <Stack spacing="sm">
        <Group position="apart" align="flex-start" noWrap>
          <div style={{ minWidth: 0 }}>
            <Text size="lg" weight={800} sx={{ lineHeight: 1.15 }}>
              {title}
            </Text>
            <Text size="sm" color="dimmed">
              {formatThroughQuarterLabel(subtitle)}
            </Text>
          </div>
          {statusLabel != null && statusColor != null ? (
            <StatusBadge
              status={mapToneToStatus(statusColor)}
              label={statusLabel}
              tooltipLabel={statusTooltip}
            />
          ) : null}
        </Group>
        {children}
      </Stack>
    </Paper>
  );
}
